import React from 'react';
import { Box, Typography, IconButton, Card, CardContent } from '@mui/material';
import { useSelector } from 'react-redux';
import { Button } from '../../Components/MUIs';
import { West as WestIcon, Close as CloseIcon } from '@mui/icons-material';

function Terms({
  type = '0',
  onClick = () => {},
  onClose = () => {},
  title = '약관 상세',
}) {
  const { statusBar, navBar } = useSelector((state) => state.systemBar);
  const ReturnContent = () => {
    switch (type) {
      case '0':
        return (
          <Box>
            <Typography variant="body1">제 1 조 (목적)</Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;이 약관은 주식회사 세이프온 (이하 “회사”라 합니다)이
              제공하는 세이프온 안전관리솔루션”(이하 “서비스”라 하며, Web, App
              이란 표현이 포함됩니다)을 이용함에 있어 회사와 이용자 간의 권리,
              의무 등 기본적인 사항을 규정하는 것을 목적으로 합니다.
            </Typography>
            <Typography variant="body1">제 2 조 (약관의 적용)</Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;본 서비스의 제휴된 모든 약관의 동일한 사항에 대해 상이한
              내용은 본 약관 및 서비스 별 안내를 우선으로 하고 본 약관에서
              정의하지 않은 사항은 대한민국 표준 약관에서 정한 바에 따릅니다.
            </Typography>
            <Typography variant="body1">제 3 조 (용어의 정의)</Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
              <br /> &ensp;① “서비스”란 회사에서 제공하는 웹, 모바일 및 온라인
              서비스로 “회사”가 제공하는 안전관리솔루션 일체를 제공하고 이에
              따른 각종 부가 가능한 서비스를 의미합니다.
              <br /> &ensp;② “이용자”란 본 약관 읽고 동의하여 서비스를 이용하는
              고객을 말합니다.
              <br /> &ensp;③ “아이디”란 세이프온을 이용하는 고유식별 문자이자
              회원의 서비스 이용을 위하여 이용자임을 선정하고 세이프온이
              부여하는 문자 및 숫자의 조합을 말합니다.
              <br /> &ensp;④ “비밀번호”란 세이프온으로부터 서비스 이용이 수락된
              이용자임을 확인하고 회원 자신의 개인정보보호를 위하여 회원 자신이
              선정한 문자와 숫자의 조합을 말합니다.
              <br /> &ensp;⑤ “근로자(노무자)”란 본사/현장 관리자 권한을 가진
              관리자로부터 승인을 받고 본인의 근무현장에 해당되는 관련 데이터
              적용 및 조회를 하는 이용자를 말합니다.
              <br /> &ensp;⑥ “관리자”란 본 약관에 동의한 서비스를 승인하고
              관리하며 모니터링하는 운영자를 말합니다.
              <br /> &emsp;1. “시스템 관리자”란 사업주의 권한을 가진 관리자를
              승인하고 본인 지역의 이력현황을 조회하는 관리자를 말합니다.
              <br /> &emsp;2. “본사/현장 관리자”란 사업주 권한을 가진
              관리자로부터 승인을 받고 본인 본사/현장을 관리 및 이력현황을
              조회하는 관리자를 말합니다.
              <br /> &ensp;⑦ “웹(Web)”이란 이용자가 앱을 통해 각종 승인이나
              안전관리를 위해 관리자가 관리 것을 의미합니다.
              <br /> &ensp;⑧ “안”이란 회사에서 정한 기준에 따라 서비스를
              이용하는 이용자를 대상으로 회사에서 제공하는 포인트로 “이용자”가
              서비스를 이용할 때(교육) 적립하는 포인트이며, 명칭은 향후 서비스
              내용에 따라 변경될 수 있습니다.
              <br /> &ensp;⑨ “부가서비스(쇼핑 외)”란 안 지불 외 서비스에서
              제공하는 각종 부가 기능으로 부가서비스 세부내용 및 이용방법 등은
              서비스 화면의 각 서비스 별 이용안내에 따릅니다. 각 서비스는
              https://www.ringvo.co.kr 에 이용방법을 게시합니다.
              <br /> &ensp;⑩ “탈퇴”라 함은 회사의 서비스 가입 후에 그 이용
              계약상의 이용관계를 장래에 대하여 소멸시키는 것을 말합니다.
            </Typography>
            <Typography variant="body1">
              제 4 조 (약관의 효력 및 변경)
            </Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;① 이 약관은 서비스를 이용하고자 하는 모든 이용자에 대하여 그
              효력이 발생합니다.
              <br /> &nbsp;② 이 약관은 회사가 이 약관의 내용을 서비스 화면에
              게시하거나 기타의 방법으로 이용자에게 공지하고, 이용자가 이에
              동의함으로써 효력이 발생합니다.
              <br /> &nbsp;③ 회사가 약관을 변경할 경우에는 약관의 규제에 관한
              법률, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 전자상거래
              등 관계법령에 위배되지 않는 범위내에서 적용일자 및 변경사유를
              명시하여 공지하며, 사용자가 약관 변경 적용일까지 명시적으로 약관
              변경 거부의사를 표시하지 아니할 경우 약관의 변경에 동의한 것으로
              간주합니다.
            </Typography>
            <Typography variant="body1">제 5 조 (약관 외 준칙)</Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;이 약관에 명시되지 않은 사항에 대해서는 약관의 규제에 관한
              법률, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 전자상거래
              등 관계법령 및 회사가 정한 각 서비스별 이용안내 등의 규정에
              따릅니다.
            </Typography>
            <Typography variant="body1">제 6 조 (이용계약의 성립)</Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;① 이용자가 회사의 “서비스”를 선택하고 이 약관에 동의함으로써
              서비스 이용의 효력이 발생합니다.
              <br /> &nbsp;② 이용자는 그 자격에 따라 서비스 이용의 일부가 제한될
              수 있으며 그 내용은 각 서비스별 이용안내에 따릅니다.
              <br /> &nbsp;③ 서비스 내용에 따라 이용자의 정보를 요청할 수 있으며
              이용자는 반드시 본인의 실제정보를 기재하여야 하며, 허위정보 또는
              부당한 방법으로 가입했을 경우 서비스 이용제한을 받으실 수
              있습니다. 그 밖에 기타 불이익과 법적 책임 또한 이용자에게
              있습니다.
              <br /> &nbsp;④ 회원등록을 원하는 이용자는 아이디 및 인증정보에
              대한 내용을 성실히 기재하여야 합니다.
              <br /> &nbsp;⑤ 변경될 서비스의 내용을 이용자에게 이메일 또는
              공지사항으로 통해 이용자에게 알리며 정한 서비스를 변경하여 제공할
              수 있습니다.
            </Typography>
            <Typography variant="body1">제 7 조 (서비스 이용)</Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;① 이용자는 “세이프온” 앱에서 “서비스”를 선택하고 가입절차를
              진행하고 본인인증을 마치면 회사가 부여한 자격에 따라 즉시 서비스를
              이용할 수 있습니다.
              <br /> &nbsp;② 서비스의 이용은 연중무휴를 원칙으로 합니다. 단,
              회사의 업무상이나 기술상의 이유로 서비스가 일시 중지될 수 있으며
              운영상의 목적으로 회사가 정한 기간에는 서비스가 일시 중지될 수
              있습니다. 이러한 경우 회사는 사전에 또는 사후에 이를 공지합니다.
            </Typography>
            <Typography variant="body1">제 8 조(포인트 및 제휴)</Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;① 이용자는 회사에서 제공하는 기본 서비스 외 부가서비스를
              이용할 수 있으며 서비스 내용에 따라 회사는 안를 이용자에게 지급할
              수 있습니다.
              <br /> &nbsp;② 회사의 제휴사항에 따라 부가서비스 세부내용 및 이용
              조건등은 각 서비스 별 이용안내를 통해 추가될 수 있습니다.
            </Typography>
            <Typography variant="body1">
              제 9 조(서비스 이용의 제한 및 정지)
            </Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;① 회사는 이용자가 다음 각 호의 1 에 해당하는 경우 사전 통지
              없이 서비스 이용을 제한 또는 정지하거나 직권 해지를 할 수
              있습니다.
              <br /> &emsp;1. 다른 사람의 명의 등을 이용하여 서비스를 이용한
              경우
              <br /> &emsp;2. 타인의 개인정보를 도용하는 등 타인의 서비스 이용을
              방해하는 경우
              <br /> &emsp;3. 서비스를 이용하여 법령에 반하는 행위를 한 경우
              <br /> &emsp;4. 회사가 무상으로 지급한 포인트를 현금융통 등
              비정상적인 목적으로 서비스를 이용한 경우
              <br /> &emsp;5. 본 약관 13 조의 의무를 위반하여 회사의 시정요구
              또는 제재를 받고도 위반행위를 중단하지 않은 경우
            </Typography>
            <Typography variant="body1">
              제 10 조(서비스의 변경 및 중지)
            </Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;① 회사는 다음 각 호의 1 에 해당하는 경우 이용자에 대한
              서비스의 전부 또는 일부를 제한, 변경하거나 중지할 수 있습니다.
              <br /> &emsp;1. 서비스 관련 설비의 보수 등 시스템 정비로 인한
              부득이한 경우
              <br /> &emsp;2. 정전, 제반 설비에 장애 또는 이용 량의 폭주 등으로
              정상적인 서비스 이용에 지장이 있는 경우
              <br /> &emsp;3. 서비스 제휴업체와의 계약 종료 등과 같이 회사의
              제반 사정 또는 법률상의 장애 등으로 서비스를 유지할 수 없는 경우
              <br /> &emsp;4. 기타 천재지변, 국가비상사태 등 불가항력적인 사유가
              있는 경우
              <br /> &nbsp;② 본 조 제 1 항에 의한 서비스 중단의 경우에는 회사는
              어플리케이션 등에 공지하는 방법으로 이용자에게 통지합니다. 다만,
              회사가 통제할 수 없는 사유로 인한 서비스의 중단(운영자의 고의,
              과실이 없는 디스크 장애, 시스템 다운 등)으로 인하여 사전 통지가
              불가능한 경우에는 사후에 통지합니다.
            </Typography>
          </Box>
        );
      case '1':
        return (
          <Box>
            <Typography variant="body1">제 11 조(서비스 종류)</Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;① 서비스 종류는 이용자에게 제공되는 어플리케이션에서
              제공되는 모든 기능을 말하며 서비스의 이용 가능 시점(개시 시점)등은
              서비스 운영사항에 따라 다를 수 있으며 서비스 내용의 추가 및 변경
              등은 회사에서 사전 혹은 사후 공지를 통하여 알립니다.
              <br /> &nbsp;② 서비스 별 변경사항 발생 시 회사는 공지 또는 각
              서비스별 이용안내를 통해 이용자에게 변경 사항을 알립니다.
            </Typography>
            <Typography variant="body1">제 12 조(회사의 의무)</Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;① 회사는 약관의 규제에 관한 법률, 정보통신망 이용촉진 및
              정보보호 등에 관한 법률, 전자상거래 등 서비스의 운영, 유지와 관련
              있는 법규를 준수합니다.
              <br /> &nbsp;② 회사는 최적화된 서비스를 제공하고, 플랫폼이나
              이벤트 정보안내, 설문조사 등 고객 지향적인 마케팅을 수행하기 위해
              이용계약 체결 시 수집한 이용자의 개인정보 및 서비스 이용과 관련한
              정보(개인정보 취급동의)를 활용할 수 있습니다. 단, 이용자의 동의
              범위를 초과하여 이용하거나 제 3 자에게 제공하고자 하는 경우에는
              미리 이용자에게 동의를 받아야 합니다. 이 경우 이용자는 회사의
              동의요청을 거절할 수 있습니다.
              <br /> &nbsp;③ 회사가 이용자에 대하여 통지할 사항이 있는 경우에는
              이용자가 회사에 제공한 이동전화번호로 문자메시지, Push 메시지, SNS
              또는 유선안내 등을 통해 통지할 수 습니다.
              <br /> &nbsp;④ 회사는 불특정 다수 이용자에 대한 통지의 경우 서비스
              어플리케이션, 홈페이지 등에 게시함으로써 개별통지에 갈음할 수
              있습니다.
              <br /> &nbsp;⑤ 회사는 Web 서비스, App 서비스의 효율적인 관리와
              원활한 운영을 위하여 운영자를 둡니다.
              <br /> &nbsp;⑥ 회사는 홈페이지를(https://www.ringvo.co.kr) 통해
              이용자와의 서비스 안내, 교육, 마케팅, 포인트 구매, 고객의 소리
              등을 운영할 수 있습니다. 또한 운영자는 이용자의 개인적인 비방이나,
              욕설 또는 음란물에 해당되는 부분에 대하여 삭제할 수 있습니다.
              <br /> &nbsp;⑦ 회사는 정보보안을 위해 서비스의 쿠키를 활용하여
              개인정보를 수집하지 아니하며 인터넷 접속파일 등 개인정보를
              자동으로 설치하는 장치를 거부하며 관련된 장치를 운영하지 않습니다.
              <br /> &nbsp;⑧ 회사는 서비스를 제공할 수 있는 서비스 투자기반의
              일부로 App, Web 에 광고게재를 할 수 있습니다. 이용자는 서비스 이용
              시 광고가 노출될 수 있습니다. 광고를 통해 광고주의 판촉활동에
              이용자가 참여하거나 거래를 함으로써 발생하는 손실과 손해에 대해
              회사는 책임지지 않습니다.
            </Typography>
            <Typography variant="body1">제 13 조(이용자의 의무)</Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;① 이용자는 서비스 이용을 위해 필요한 제반 정보를 현재의
              사실과 일치하는 완전한 정보로 제공 및 등록하여야 하며 변경사항이
              발생할 경우 즉시 갱신하여야 합니다.
              <br /> &nbsp;② 이용자는 휴대폰(휴대기기)이 정상 동작을 유지하도록
              관리하여야 하며, 휴대폰(휴대기기)이 비정상적인 동작으로 인해
              서비스 제공이 정상적으로 이루어지지 않아 발생하는 이용자의 손해에
              대해서 회사는 책임지지 않습니다.
              <br /> &nbsp;③ 이용자가 보유하고 있는 “일부 휴대폰(휴대기기)의
              문제로 서비스를 이용할 수 없는 경우” 이로 인한 이용자의 손해에
              대해서 회사는 책임지지 않습니다.
              <br /> &nbsp;④ 이용자는 서비스 이용 시 다음 각 호의 1 에 해당하는
              행위를 하여서는 아니 됩니다.
              <br /> &emsp;1. 가입신청 또는 변경 시 허위 사실을 기재하는 행위
              <br /> &emsp;2. 타인의 명예를 손상시키거나 불이익을 주는 행위
              <br /> &emsp;3. 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장,
              도형, 음성 등을 App 에 저장하는 행위
              <br /> &emsp;4. 서비스와 관련된 설비의 오동작이나 정보 등의 파괴
              및 혼란을 유발시키는 컴퓨터 바이러스 감염자료를 등록 또는 유포하는
              행위
              <br /> &emsp;5. 타인으로 가장하는 행위 및 타인과의 관계를 허위로
              명시하는 행위
              <br /> &emsp;6. 자기 또는 타인에게 재산상의 이익을 주거나 타인에게
              손해를 가할 목적으로 허위의 정보를 유통시키는 행위
              <br /> &emsp;7. 서비스의 이용과 관련하여 취득한 타인의 개인정보를
              무단으로 유용 또는 유출하는 행위
              <br /> &emsp;8. 기타 불법적이거나 부당한 행위
              <br /> &nbsp;⑤ 이용자는 관계 법령, 이 약관의 규정, 이용안내 및
              서비스상에 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야
              하며, 기타 회사의 업무에 방해되는 행위를 하여서는 아니 됩니다.
              <br /> &nbsp;⑥ 이용자는 회사에게 본 조 제 1 항에 따라 최신 정보
              제공을 하지 않아 발생하는 제반 불이익에 대해서는 회사가 책임지지
              않습니다.
              <br /> &nbsp;⑦ 이용자의 아이디와 비밀번호에 관한 모든 관리의
              책임은 이용자에게 있으며, 이용자의 아이디와 비밀번호를 부정하게
              사용하면 해당 아이디의 사용은 중지될 수 있습니다.
              <br /> &nbsp;⑧ 이용자는 퇴근 등 현장을 벗어나서 서비스를
              종료하여야 합니다. 정확히 종료하지 아니함으로써 제 3 자가 이용자의
              관련정보를 이용하게 되는 결과로 인해 발생하는 손해 및 손실에
              대하여 회사는 책임을 부담하지 아니합니다.
            </Typography>
          </Box>
        );
      case '2':
        return (
          <Box>
            <Typography variant="body1">
              제 14 조 (이용자의 개인정보보호)
            </Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;① 이용자의 개인정보 수집, 이용, 활용, 제 3 자의 제공 등에
              관한 제반 사항과 관련하여 회사는 정보통신망 이용촉진 및 정보보호
              등에 관한 법률, 정보의 이용 및 보호에 관한 법률 등 관련 법령이
              정하는 바에 따라 이용자의 개인정보를 보호하기 위해 노력하여
              이용자는 서비스 이용 시 회사의 개인정보취급방침에 동의함으로써,
              이용자의 개인정보에 대한 회사의 수집, 이용, 활용, 제 3 자의 제공
              등에 대하여 동의한 것으로 간주합니다.
              <br /> &nbsp;② 회사는 이용자의 귀책사유로 인해 노출된 정보에
              대해서 일체의 책임을 지지 않습니다.
              <br /> &nbsp;③ 개인정보는 회원가입을 하는 시점부터 서비스를
              제공하는 기간동안에만 제한적으로 이용하고 있으며, 이용자가
              회원탈퇴를 요청하거나 제공한 개인정보의 수집 및 이용에 대한 동의를
              철회하는 경우, 또는 수집 및 이용목적이 달성되거나 보유 및
              이용기간이 종료한 경우 해당 이용자의 개인정보는 지체 없이
              파기됩니다.
              <br /> &nbsp;④ 이용자는 위와 같은 개인정보 수집, 이용에 동의하지
              않을 권리가 있으며, 동의를 거부할 경우 회원가입을 할 수 없으며
              위험성평가 지원시스템에서 제공하는 서비스제공이 제한될 수
              있습니다.
              <br /> &nbsp;⑤ 회사는 이용자의 개인정보를 이용자의 승낙 없이 제 3
              자에게 누설, 배포하지 않습니다. 단, 전기통신기본법 등 법률의
              규정에 의해 국가기관의 요구가 있는 경우, 범죄에 대한 수사상의
              목적이 있거나 정보통신윤리위원회의 요청이 있는 경우 또는 기타
              관계법령에서 정한 절차에 따른 요청이 있는 경우
              <br /> &nbsp;⑥ 이용자의 개인정보의 보호 및 관리를 위하여 1 년이상
              장기 미사용인 경우 회사가 판단하여 이용자의 개인정보를 삭제/수정할
              수 있습니다.
              <br /> &nbsp;⑦ 수집하는 이용자의 개인정보
              <br /> &emsp;1. 이용자의 회원가입에 따른 이름, 휴대폰번호, 이메일,
              생년월일 등
              <br /> &emsp;2. 서비스를 이용하기 위한 App 내 필수 정보
              <br /> &emsp;3. 기타 이용자에게 고지한 정보
              <br /> &nbsp;⑧ 자동 수집되는 이용자의 IP 주소, 쿠키, 서비스
              이용기록, 방문기록, 불량이용기록 등
              <br /> &nbsp;⑨ 개인정보의 보유 및 이용기간은 10년이며 회사의
              서비스는 원칙적으로 보유기간의 경과, 개인정보의 수집 및 이용목적의
              달성 등 그 개인정보가 불필요하게 되었을 때에는 지체없이
              파기합니다. 다만, 다른 법령에 따라 보존하여야 하는 경우에는
              그러하지 않을 수 있습니다. 이용자의 개인정보가 불필요하게 되었을
              때에는 지체 없이 해당 개인정보를 파기합니다.
              <br /> &nbsp;⑩ 외국인 이용자의 국제협정의 이행을 위하여 외국정보
              또는 정부, 국제기구에 제공하기 위하여 필요한 경우는 이용자의
              정보를 제공할 수 있습니다. 이는 외국인 이용자에만 해당됩니다.
            </Typography>
            <Typography variant="body1">
              제 14 조-1 (동의 거부권 및 불이익)
            </Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;이용자는 개인정보의 제 3 자 제공에 동의를 거부할 권리가
              있습니다. 다만, 서비스를 이용하기 위해 필수 항목으로 거부하실 경우
              회원가입이 제한될 수 있습니다.
            </Typography>
            <Typography variant="body1">
              제 14 조-2 (게시물에 대한 저작권)
            </Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;“세이프온 안전관리솔루션”(“서비스”) 이용자는 회원가입 후
              서비스를 이용하여 취득한 정보를 임의 가공, 판매하는 행위 등과
              서비스에 게재된 Web, App 의 모든 자료를 상업적으로 사용할 수
              없으며, 무단으로 사용 시 법적 책임을 지게 됩니다.
            </Typography>
            <Typography variant="body1">제15조 (회사의 연락처)</Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;① 회사의 상호, 주소, 이메일 연락처는 다음과 같습니다.
              <br /> &emsp;1. 상호 : 주식회사 세이프온
              <br /> &emsp;2. 주소 : 부산광역시 중구 중앙대로 129, 4층 402호
              (대창동1가, JBG빌딩)
              <br /> &emsp;3. E-mail : safeon_support@safeoncorp.com
            </Typography>
          </Box>
        );
      case '3':
        return (
          <Box>
            <Typography variant="body1">제 16 조(양도금지)</Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;이용자 및 회사는 이용자의 서비스 가입에 따른 이용 약관상의
              지위 또는 권리, 의무의 전부 또는 일부를 제 3 자에게 양도,
              위임하거나 담보제공 등의 목적으로 처분할 수 없습니다.
            </Typography>
            <Typography variant="body1">제 17 조(손해배상)</Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &emsp;① 이용자가 이 약관의 규정을 위반함으로 인하여 회사에 손해가
              발생하게 되는 경우, 이 약관을 위반한 이용자는 회사에 발생하는
              손해를 배상하여야 합니다.
              <br /> &emsp;② 이용자가 서비스를 이용함에 있어 행한 불법행위나 이
              약관위반행위로 인하여 회사가 당해 이용자 이외의 제 3 자로부터
              손해배상청구 또는 소송을 비롯한 각종 이의제기를 받는 경우 당해
              이용자는 자신의 책임과 비용으로 회사를 면책시켜야 하며, 회사가
              면책되지 못한 경우 당해 이용자는 그로 인하여 회사에 발생한 손해를
              배상하여야 합니다.
            </Typography>
          </Box>
        );
      case '4':
        return (
          <Box>
            <Typography variant="body1">제 18 조(면책사항)</Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;① 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여
              서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이
              면제됩니다.
              <br /> &nbsp;② 회사는 이용자의 귀책사유로 인한 서비스의 이용장애에
              대하여 책임을 지지 않습니다.
              <br /> &nbsp;③ 회사에서 제공하는 서비스 및 서비스를 이용하여 얻은
              정보에 대한 최종판단은 이용자가 직접 하여야 하고, 그에 따른 책임은
              전적으로 이용자 자신에게 있으며, 회사는 그로 인하여 발생하는
              손해에 대해서 책임을 부담하지 않습니다.
              <br /> &nbsp;④ 회사의 업무상 또는 기술상의 장애로 인하여 서비스를
              개시하지 못하는 경우 회사는 어플리케이션 등에 이를 공지하거나
              문자메시지, Push 메세지, SNS 등의 방법으로 이용자에게 통지합니다.
              단, 회사가 통제할 수 없는 사유로 인하여 사전 공지가 불가능한
              경우에는 사후에 공지합니다.
              <br /> ⑤ 회원에게 무료로 제공하는 서비스 관련해서는 어떠한 손해도
              책임을 지지 않습니다.
            </Typography>
            <Typography variant="body1">
              제 19 조(분쟁의 해결 및 관할법원)
            </Typography>
            <Typography sx={{ mb: 2 }} variant="body2">
              &nbsp;① 서비스 이용과 관련하여 회사와 이용자 사이에 분쟁이 발생한
              경우, 회사와 이용자는 분쟁의 해결을 위해 성실히 협의합니다.
              <br /> &nbsp;② 본 조 제 1 항의 협의에도 불구하고 분쟁이 해결되지
              않을 경우 양 당사자는 민사소송법상의 관할법원에 소를 제기할 수
              있습니다.
            </Typography>
          </Box>
        );
      default:
        return <Box />;
    }
  };

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#FFFFFF',
        position: 'relative',
      }}
    >
      {/* 상단 네비게이션 바 */}
      <Box
        sx={{
          height: `${statusBar + 56}px`,
          width: '100%',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: '1px solid #E5E7EB',
          flexShrink: 0,
          paddingTop: `${statusBar}px`,
        }}
      >
        {/* 뒤로가기 버튼 */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            left: '16px',
            color: '#111827',
          }}
        >
          <WestIcon sx={{ fontSize: '24px' }} />
        </IconButton>

        {/* 제목 */}
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 700,
            lineHeight: '32px',
            color: '#111827',
          }}
        >
          {title}
        </Typography>

        {/* 닫기 버튼 */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: '16px',
            color: '#111827',
          }}
        >
          <CloseIcon sx={{ fontSize: '24px' }} />
        </IconButton>
      </Box>

      {/* 메인 콘텐츠 영역 */}
      <Box
        sx={{
          flex: 1,
          overflow: 'auto',
          px: 3,
          py: 3,
          pb: '112px',
          backgroundColor: '#F8FAFC',
        }}
      >
        <Card
          sx={{
            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
            borderRadius: '8px',
          }}
        >
          <CardContent sx={{ p: 3 }}>{ReturnContent()}</CardContent>
        </Card>
      </Box>

      {/* 하단 확인 버튼 - 고정 */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          p: 2,
          pb: `calc(16px + ${navBar}px)`,
          backgroundColor: '#FFFFFF',
          borderTop: '1px solid #E5E7EB',
          zIndex: 10,
          flexShrink: 0,
        }}
      >
        <Button
          name="확인"
          fullWidth
          onClick={onClick}
          sx={{
            backgroundColor: '#2EBD36',
            color: '#FFFFFF',
            fontSize: '17px',
            fontWeight: 600,
            height: '55px',
            borderRadius: '16px',
            boxShadow: '0 10px 15px -3px rgba(46, 189, 54, 0.25)',
            textTransform: 'none',
            transition: 'all 0.2s',
            '&:hover': {
              backgroundColor: '#16A34A',
              boxShadow: '0 10px 15px -3px rgba(46, 189, 54, 0.35)',
              transform: 'scale(0.98)',
            },
            '&:active': {
              transform: 'scale(0.98)',
            },
          }}
        ></Button>
      </Box>
    </Box>
  );
}

export default Terms;
